import Vue from "vue";
import { newLogger } from "@/utils/util";
import network from "../../../utils/network";

let logger = newLogger("UserStore");

const urls = {
  user: `/merchant/user`,
  userWithId: (id) => `/merchant/user/${id}`,
  users: `/merchant/user/users`,
  usersWithQuery: (query) => `/merchant/user/users?${query}`,
  lock: "/bulwark/merchant/lock",
  reset: (id) => `/bulwark/merchant/${id}/reset`,
};

const initState = () => {
  return {
    users: [],
    user: {},
  };
};

const actions = {
  fetchList: async ({ commit }, query) => {
    try {
      const axios = await network.connection();
      let url = urls.users;
      if (query) {
        url = urls.usersWithQuery(query);
      }
      let { data } = await axios.get(url);
      commit("saveUsers", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetch: async ({ commit }, id) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.userWithId(id));
      commit("saveUser", { data: data, id: id });
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  create: async ({}, request) => {
    try {
      const axios = await network.connection();
      await axios.post(urls.user, request);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  update: async ({}, { id, request }) => {
    try {
      const axios = await network.connection();
      await axios.put(urls.userWithId(id), request);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  reset: async ({}, userId) => {
    try {
      const axios = await network.connection();
      await axios.post(urls.reset(userId));
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  lock: async ({}, request) => {
    try {
      const axios = await network.connection();
      await axios.post(urls.lock, request);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  saveUsers: (state, data) => {
    Vue.set(state, "users", data);
  },
  saveUser: (state, { data, id }) => {
    Vue.set(state.user, id, data);
  },
};

const getters = {
  getList: (state) => {
    return state.users;
  },
  get: (state) => (id) => {
    return state.user[id];
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
